export const ConfirmDialogResults = ['REJECT', 'CONFIRM', false] as const;
export type ConfirmDialogResultsType = typeof ConfirmDialogResults[number];

export interface ConfirmDialogAnswer {
  result: ConfirmDialogResultsType;
  data: string | null;
}

export interface ConfirmDialogData {
  text: string;
  reject: string;
  confirm: string;
  message: boolean;
  isHighlightForConfirm: boolean;
}

export enum TextsForErrorsDialogs {
  CLOSE = 'ConnectionFailure.close',
  PROCESSING_ERROR_PLEASE_REFRESH = 'PROCESSING_ERROR_PLEASE_REFRESH',
  PROCESSING_ERROR_INVALID_FILE_TYPE = 'PROCESSING_ERROR_INVALID_FILE_TYPE',
}
